import terms from 'pages/Terms/dict'

const {
  TERMS_OF_USE,
  PRIVACY_POLICY,
  COOKIES_POLICY,
  DELETION_POLICY,
  INFORMATION_SECURITY,
} = terms

const links = [
  {
    title: 'Institucional',
    links: [
      {
        name: 'Fale Conosco',
        link: '/fale-conosco',
      },
      {
        name: 'Quero vender imóveis da EMGEA',
        link: '/seja-um-parceiro',
      },
    ],
  },
  {
    title: 'Área do Cliente',
    links: [
      {
        name: 'Minhas Propostas',
        link: 'https://clientes.pagimovel.com.br/welcome/login',
      },
      {
        name: 'Ajuda',
        link: '/perguntas-frequentes',
      },
    ],
  },
  {
    title: 'Termos e Privacidade',
    links: [
      {
        name: 'Termos e Condições de Uso',
        link: '/termos',
        term: TERMS_OF_USE,
      },
      {
        name: 'Política de Privacidade',
        link: '/termos/privacidade',
        term: PRIVACY_POLICY,
      },

      {
        name: 'Política de Cookies',
        link: '/termos/cookies',
        term: COOKIES_POLICY,
      },
      {
        name: 'Política de Exclusão de Dados',
        link: '/termos/exclusao_de_dados',
        term: DELETION_POLICY,
      },
      {
        name: 'Política de Segurança da Informação',
        link: '/termos/seguranca_da_informacao',
        term: INFORMATION_SECURITY,
      },
    ],
  },
]
export { links }
